import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { Note } from '../../../helbest';
import { API } from '../../../request/api';

const useChangeStoreLocation = (cartClean, setStore) => {
  const [city_name, set_city_name] = useState('');
  const [loading, set_loading] = useState(false);
  const [province_list, set_province_list] = useState([]);
  const [selected_city, set_selected_city] = useState('');
  const [province_name, set_province_name] = useState('');
  const [selected_province, set_selected_province] = useState('');
  const [city_list, set_city_list] = useState([]);

  const history = useHistory();

  const getProvince = () => {
    API.get
      .locationProvince()
      .then((response) => {
        if (response.success) {
          set_province_list(response.data);
          set_loading(false);
        } else {
          Note.error(response.message);
        }
        return response;
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error('Error : ', error);
      });
  };

  const getCity = (province_id = 1) => {
    API.get
      .locationCities(province_id)
      .then((response) => {
        if (response.success) {
          if (response.data.length === 1) {
            set_selected_city(response.data[0].id);
            set_city_name(response.data[0].name);
          }
          set_city_list(response.data);
          set_loading(false);
        } else {
          Note.error(response.message);
        }
        return response;
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error('Error : ', error);
      });
  };

  const select_province = (e) => {
    let pn;
    province_list.forEach((item) => {
      if (item.id === parseInt(e, 10)) {
        pn = item.name;
      }
    });
    set_loading(true);
    set_selected_province(e);
    set_selected_city('');
    set_province_name(pn);
    getCity(e);
  };

  const select_city = (e) => {
    let cn;
    city_list.forEach((item) => {
      if (item.id === parseInt(e, 10)) {
        cn = item.name;
      }
    });

    set_selected_city(e);
    set_city_name(cn);
  };

  const set_store = () => {
    if (select_province === '' || selected_city === '') {
      Note.error('لطفا استان و شهر خود را انتخاب کنید.');
      return;
    }
    cartClean();
    setStore(selected_province, selected_city, '', province_name, city_name);
    set_loading(false);
    history.push('/');
  };

  useEffect(() => {
    getProvince();
  }, []);

  return [
    loading,
    province_list,
    selected_province,
    city_list,
    select_province,
    select_city,
    set_store
  ];
};

export default useChangeStoreLocation;
